import { FC, ReactNode } from 'react'
import { RoleAvatar, RoleAvatarType } from './RoleAvatar'
import { RoleTag, RoleTagType } from './RoleTag'

const Role: FC & RoleAvatarType & RoleTagType = (): ReactNode => <></>

Role.Avatar = RoleAvatar
Role.Tag = RoleTag

export default Role
